export default "__VITE_ASSET__DJOl6w1h__"